import MuiPopover from '@material-ui/core/Popover';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import styled from 'styled-components';

export const Popover = styled(MuiPopover)`
  .MuiPaper-root {
    width: 300px;
    ${props => props.theme.shadows[1]};
    border: 1px solid ${props => props.theme.palette.divider};
  }
`;

export const Indicator = styled(Badge)`
  .MuiBadge-badge {
    background: ${props => props.theme.header.indicator.background};
    color: ${props => props.theme.palette.common.white};
  }
`;

export const NotificationHeader = styled(Box)`
  text-align: center;
  border-bottom: 1px solid ${props => props.theme.palette.divider};
`;
